import { type Bid } from '../domain/Bid'
import { BookingType } from '../domain/LoadOffer'
import { getBidCounterPrice, getBidPrice } from './bidPresenter'

export function getHeaderTitle(bookingType: BookingType) {
  switch (bookingType) {
    case BookingType.BidAward:
      return 'Bid accepted'
    case BookingType.BidCounter:
      return 'Counter offer'
    case BookingType.BidTooHigh:
      return 'Your bid was too high'
    default:
      return 'Booking confirmation'
  }
}

export function getSubtitle(bookingType: BookingType, bid?: Nullable<Bid>) {
  switch (bookingType) {
    case BookingType.BidAward:
      return 'Review the load details before accepting'
    case BookingType.BidCounter:
      const bidPrice = bid ? getBidPrice(bid) : null
      const bidCounterPrice = bid ? getBidCounterPrice(bid) : null
      if (!bidPrice || !bidCounterPrice) return 'We cannot accept your offer at this moment'
      return `We cannot accept your ${bidPrice} offer at this moment. Our best rate for this load is ${bidCounterPrice}.`
    case BookingType.BidTooHigh:
      return 'You can try bidding again with a lower bid'
    default:
      return 'Please confirm your booking to proceed'
  }
}

export function getConfirmButtonLabel(bookingType: BookingType) {
  switch (bookingType) {
    case BookingType.BidAward:
    case BookingType.BidCounter:
      return 'Accept load'
    case BookingType.BidTooHigh:
      return 'Book now'
    default:
      return 'Confirm'
  }
}

export function getCancelButtonLabel(bookingType: BookingType) {
  switch (bookingType) {
    case BookingType.BidAward:
    case BookingType.BidCounter:
      return 'Decline load'
    case BookingType.BidTooHigh:
      return 'Bid again'
    default:
      return 'Cancel'
  }
}
